import { Alert, Box, Button, FormControl, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Logo from '../../Layout/Logo/Logo.jsx'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import LoginForm from '../../Shared/Forms/LoginForm.jsx'

const Login = () => {
  const { setResetPasswordDialog } =
    useGlobalContext()
  const { saveCurrentUser, useLoginUser, authState } = useAuth()

  const navigate = useNavigate()

  useEffect(() => {
    if (authState.isAuthenticated) {
      navigate('/select-test')
    }
  }, [])

  const [isValid, setIsValid] = useState(false)
  const [form, setForm] = useState({
    email: '',
    password: ''
  })
  const [isLoginError, setIsLoginError] = useState(false)
  const [loginErrorMessage, setLoginErrorMessage] = useState(t('users.loginFail'))

  const handleLoginFormChange = (loginForm, isValid) => {
    setForm(loginForm)
    setIsValid(isValid)
  }

  const handleCloseLogin = () => {
    navigate('/select-test')
  }

  const handleResetPassword = () => {
    setResetPasswordDialog(true)
  }

  const handleLogin = () => {
    if (!isValid) {
      return
    }
    useLoginUser(form)
      .then(({ data: loginData }) => {
        saveCurrentUser(loginData)
        setIsValid(false)
        setForm({
          email: '',
          password: ''
        })
        handleCloseLogin()
      })
      .catch((err) => {
        const message = err.status === 401 ? t('users.loginFail') : t('users.noOrganizations')
        setIsLoginError(true)
        setLoginErrorMessage(message)
      })
  }

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Stack
        direction="column"
        spacing={2}
        paddingTop={3}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ width: '100%' }}
        >
          <Logo />
        </Box>

        <Typography
          variant="h3"
          align="center"
        >
          <strong>{t('users.loginToCityEye')}</strong>
        </Typography>
        <Typography
          variant="body2"
          align="center"
        >
          {t('users.handleYourDevices')}
        </Typography>
      </Stack>

      <Stack
        direction="column"
        maxWidth="80%"
        py={2}
        spacing={2}
      >
        <LoginForm
          onChange={handleLoginFormChange}
          onLogin={handleLogin}
        />
        {isLoginError && (
          <Alert severity="error">{loginErrorMessage}</Alert>
        )}
        <FormControl variant="standard">
          <Button
            id="login-dialog-button-login"
            sx={{ mt: 4 }}
            variant="contained"
            onClick={handleLogin}
            disabled={!isValid}
          >
            {t('common.login')}
          </Button>
        </FormControl>

        <Button
          variant="text"
          onClick={handleResetPassword}
          size="small"
        >
          <Typography variant="body2">
            <>{t('users.forgotPassword')}</>
          </Typography>
        </Button>
      </Stack>
    </Stack>
  )
}

export default Login
